export const excludedFields = ["id", "created_at", "updated_at"];
export const dateFields = ["install_date"];
